import { getStaticProps as pageGetStaticProps } from '@/pages/pakiety/[slug]'
export { default, getStaticPaths } from '@/pages/pakiety/[slug]'

export function getStaticProps(ctx: any) {
  return pageGetStaticProps({ ...ctx, locale: 'en' })
}
